import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, KiloClassBulkCreate, KiloClassBulkCreateResult } from 'types';
import { client } from 'utils/api-client';

export default function useBulkCreateKiloClass(): UseMutationResult<
  AxiosResponse<KiloClassBulkCreateResult>,
  AxiosError<ErrorMessage>,
  KiloClassBulkCreate
> {
  const queryClient = useQueryClient();

  const bulkCreateKiloClass = (
    payload: KiloClassBulkCreate,
  ): Promise<AxiosResponse<KiloClassBulkCreateResult>> => {
    return client.post('kilo-classes/create-bulk/', payload);
  };

  return useMutation(bulkCreateKiloClass, {
    onSuccess: () => {
      queryClient.invalidateQueries('classes');
      queryClient.invalidateQueries('events');
      queryClient.invalidateQueries(['workouts', 'calendar']);
    },
  });
}
